import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TSvgIconProps } from '../icon.component';

const PdsNovios = forwardRef(
  ({ ...props }: TSvgIconProps, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 32 32"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.53033 23.9697C7.82322 24.2626 7.82322 24.7374 7.53033 25.0303L6.37648 26.1842C6.08359 26.4771 5.60872 26.4771 5.31582 26.1842C5.02293 25.8913 5.02293 25.4164 5.31582 25.1235L6.46967 23.9697C6.76256 23.6768 7.23744 23.6768 7.53033 23.9697Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68414 27.8158C3.97703 28.1087 3.97703 28.5836 3.68414 28.8765L2.53029 30.0303C2.2374 30.3232 1.76253 30.3232 1.46963 30.0303C1.17674 29.7374 1.17674 29.2625 1.46963 28.9696L2.62348 27.8158C2.91637 27.5229 3.39125 27.5229 3.68414 27.8158Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.46966 23.9697C1.76255 23.6768 2.23743 23.6768 2.53032 23.9697L3.68417 25.1235C3.97706 25.4164 3.97706 25.8913 3.68417 26.1842C3.39127 26.4771 2.9164 26.4771 2.62351 26.1842L1.46966 25.0303C1.17677 24.7374 1.17677 24.2626 1.46966 23.9697Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.31585 27.8158C5.60875 27.5229 6.08362 27.5229 6.37651 27.8158L7.53036 28.9696C7.82325 29.2625 7.82325 29.7374 7.53036 30.0303C7.23747 30.3232 6.76259 30.3232 6.4697 30.0303L5.31585 28.8765C5.02296 28.5836 5.02296 28.1087 5.31585 27.8158Z"
          fill="#006DFF"
        />
        <path
          d="M20 4.50006C20 3.94778 20.4477 3.50006 21 3.50006C21.5523 3.50006 22 3.94778 22 4.50006C22 5.05235 21.5523 5.50006 21 5.50006C20.4477 5.50006 20 5.05235 20 4.50006Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4697 7.53034C24.1768 7.23745 24.1768 6.76257 24.4697 6.46968L25.6235 5.31583C25.9164 5.02294 26.3913 5.02294 26.6842 5.31583C26.9771 5.60873 26.9771 6.0836 26.6842 6.37649L25.5303 7.53034C25.2374 7.82323 24.7626 7.82323 24.4697 7.53034Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3159 3.68421C28.023 3.39132 28.023 2.91644 28.3159 2.62355L29.4697 1.4697C29.7626 1.17681 30.2375 1.17681 30.5304 1.4697C30.8233 1.76259 30.8233 2.23747 30.5304 2.53036L29.3765 3.68421C29.0836 3.9771 28.6088 3.9771 28.3159 3.68421Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5303 7.53033C30.2374 7.82322 29.7626 7.82322 29.4697 7.53033L28.3158 6.37648C28.0229 6.08359 28.0229 5.60872 28.3158 5.31582C28.6087 5.02293 29.0836 5.02293 29.3765 5.31582L30.5303 6.46967C30.8232 6.76256 30.8232 7.23744 30.5303 7.53033Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6841 3.6842C26.3913 3.97709 25.9164 3.97709 25.6235 3.6842L24.4696 2.53035C24.1767 2.23746 24.1767 1.76259 24.4696 1.46969C24.7625 1.1768 25.2374 1.1768 25.5303 1.46969L26.6841 2.62354C26.977 2.91643 26.977 3.39131 26.6841 3.6842Z"
          fill="#006DFF"
        />
        <path
          d="M7 1.92308L9.49998 1H14.4999L16.9999 1.92308L17 4.69231L13.6667 6.20093L12 7L10.3334 6.20093L7.00008 4.69231L7 1.92308Z"
          fill="#E4E0FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6667 6.20093L17 4.69231L16.9999 1.92308L14.4999 1H9.49998L7 1.92308L7.00008 4.69231L10.3334 6.20093L12 7L13.6667 6.20093ZM12 5.33651L13.0331 4.8412L15.5 3.72473L15.5 2.96822L14.2319 2.5H9.76806L8.50003 2.9682L8.50005 3.7247L10.9669 4.8412L12 5.33651Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.66457 1.32916C10.0351 1.14392 10.4856 1.29409 10.6708 1.66457L12 4.32293L13.3292 1.66457C13.5144 1.29409 13.9649 1.14392 14.3354 1.32916C14.7059 1.5144 14.856 1.96491 14.6708 2.33539L12.6708 6.33539C12.5438 6.58948 12.2841 6.74998 12 6.74998C11.7159 6.74998 11.4562 6.58948 11.3292 6.33539L9.32916 2.33539C9.14392 1.96491 9.29409 1.5144 9.66457 1.32916Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 29.5C23.6944 29.5 27.5 25.6944 27.5 21C27.5 16.3056 23.6944 12.5 19 12.5C14.3056 12.5 10.5 16.3056 10.5 21C10.5 25.6944 14.3056 29.5 19 29.5ZM19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 26.5C22.0376 26.5 24.5 24.0376 24.5 21C24.5 17.9624 22.0376 15.5 19 15.5C15.9624 15.5 13.5 17.9624 13.5 21C13.5 24.0376 15.9624 26.5 19 26.5ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3288 23.6912C19.1288 22.405 21.9773 17.4712 20.6911 12.6712C19.405 7.8712 14.4712 5.02267 9.6712 6.30882C4.8712 7.59498 2.02267 12.5288 3.30882 17.3288C4.59498 22.1288 9.52878 24.9773 14.3288 23.6912ZM13.5525 20.7941C16.7525 19.9367 18.6515 16.6475 17.7941 13.4475C16.9367 10.2475 13.6475 8.34844 10.4475 9.20588C7.24746 10.0633 5.34844 13.3525 6.20588 16.5525C7.06331 19.7525 10.3525 21.6515 13.5525 20.7941Z"
          fill="#C0AAFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1643 19.3452C15.5641 18.7022 16.9883 16.2355 16.3452 13.8357C15.7022 11.4359 13.2355 10.0117 10.8357 10.6548C8.4359 11.2978 7.01175 13.7645 7.65477 16.1643C8.2978 18.5641 10.7645 19.9883 13.1643 19.3452ZM13.5525 20.7941C16.7525 19.9367 18.6516 16.6475 17.7941 13.4475C16.9367 10.2475 13.6475 8.34844 10.4475 9.20588C7.24747 10.0633 5.34845 13.3525 6.20588 16.5525C7.06332 19.7525 10.3525 21.6516 13.5525 20.7941Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9406 22.2423C17.9404 21.1705 20.314 17.0592 19.2423 13.0594C18.1705 9.05963 14.0592 6.68597 10.0594 7.75771C6.05963 8.82946 3.68597 12.9408 4.75771 16.9406C5.82946 20.9404 9.94076 23.314 13.9406 22.2423ZM14.3288 23.6912C19.1288 22.405 21.9773 17.4712 20.6912 12.6712C19.405 7.8712 14.4712 5.02267 9.67121 6.30882C4.8712 7.59498 2.02267 12.5288 3.30882 17.3288C4.59498 22.1288 9.52879 24.9773 14.3288 23.6912Z"
          fill="#0F3893"
        />
        <mask
          id="mask0_1461_2691"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="14"
          y="11"
          width="8"
          height="5"
        >
          <rect x="14" y="11" width="8" height="5" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1461_2691)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
            fill="#006DFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 29.5C23.6944 29.5 27.5 25.6944 27.5 21C27.5 16.3056 23.6944 12.5 19 12.5C14.3056 12.5 10.5 16.3056 10.5 21C10.5 25.6944 14.3056 29.5 19 29.5ZM19 31C24.5228 31 29 26.5228 29 21C29 15.4772 24.5228 11 19 11C13.4772 11 9 15.4772 9 21C9 26.5228 13.4772 31 19 31Z"
            fill="#0F3893"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 26.5C22.0376 26.5 24.5 24.0376 24.5 21C24.5 17.9624 22.0376 15.5 19 15.5C15.9624 15.5 13.5 17.9624 13.5 21C13.5 24.0376 15.9624 26.5 19 26.5ZM19 28C22.866 28 26 24.866 26 21C26 17.134 22.866 14 19 14C15.134 14 12 17.134 12 21C12 24.866 15.134 28 19 28Z"
            fill="#0F3893"
          />
        </g>
      </svg>
    );
  }
);

export default PdsNovios;
